Monitoring.Views ||= {}
class Monitoring.Views.SocialContentNoteView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents/note"]
  className: "content-note"
  events:
    'click .delete-note': 'delete'

  initialize: (@options = {}) ->
    @note = @options.note

  render: ->
    @$el.html(@template({ note: @note }))
    @$el.css('padding-left', '29px') unless @note.deletable
    return this

  delete: =>
    swal({
        title: 'Delete note?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: 'Yes, delete',
        closeOnConfirm: true
      }, =>
        $.ajax
          type: 'DELETE'
          url: '/monitoring/dashboard/notes/' + @note.id
          success: (response) =>
            @remove()
            @trigger('decrementCounter')
    )
